import { USER_TIMELIME_STATUS } from './enums';

export const GOOGLE = 'google.com';

export const IVR_DATA = {
    SERVICE_ADVISOR_NUMBER: '18002669293',
    SERVICE_ADVISOR_NAME: 'Acko Drive Service Centre',
};

export const REPEAT_BOOKING = 'repeat-booking';

export const SCHEMA_LINK = 'https://schema.org';

export const DEFAULT_PACKAGE_AMOUNT = 5000;
export const DEFAULT_TOTAL_AMOUNT = 0;

export const DEFAULT_MULTIPLE_COUPON_VALUE = 'multiple';

export const REWARD_FALLBACK_MESSAGE = 'Special discount unlocked';
export const DEFAULT_REWARD_DESCRIPTION =
    'You’ve unlocked an exclusive discount!';
export const ACKO_ASSET_X_ASSET_NAME_CAR = 'car';
export const ACKO_ASSET_X_CHANNEL_NAME = 'ackodrive-service-center';
export const ACKO_ASSET_X_SOURCE_APP = 'garage-frontend';

export const PUD_TRACKER_ENUMS = [
    USER_TIMELIME_STATUS.PICKUP_START_TRIP,
    USER_TIMELIME_STATUS.PICKUP_VEHICLE_PICKED,
    USER_TIMELIME_STATUS.PICKUP_REACHED_GARAGE,
    USER_TIMELIME_STATUS.DROP_SCHEDULED,
    USER_TIMELIME_STATUS.DROP_SELF_SCHEDULED,
    USER_TIMELIME_STATUS.DROP_VEHICLE_PICKED,
    USER_TIMELIME_STATUS.DROP_REACHED_CUSTOMER,
    USER_TIMELIME_STATUS.DROP_SELF_REACHED_CUSTOMER,
];
